<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :contentStyle="{'height': '100%'}"
      size="910x650"
      :loading="modalLoading"
      :confirm-loading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>预警设置</span><span class="modal-secondary-title">{{ tplName }}</span>
    </template>

    <template #content>
      <el-form
          class="warning-form"
          ref="form"
          :model="form"
          label-width="70px">
        <el-form-item label="预警标题" prop="warnTitleName">
          <gj-input
              v-model="form.warnTitleName"
              width="190px"
              disabled
              :clearable="false"
              placeholder="请输入名称"
          ></gj-input>
        </el-form-item>

        <el-form-item label="状态">
          <el-radio-group v-model="form.warnStatus" disabled>
            <el-radio :label="true">启用</el-radio>
            <el-radio :label="false">停用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="触发条件" required style="margin-bottom: 0">
          <div v-for="(val,index) in form.conditionList" :key="val.id" class="flex-message">

<!--            第一列-->
            <el-form-item class="right-padding-10" :title="val.paramName">
              <gj-input
                  v-model="val.paramName"
                  width="240px"
                  disabled
                  :clearable="false"
              ></gj-input>
            </el-form-item>

<!--            第二列-->
            <el-form-item class="right-padding-10" v-if="switchCondition(val.paramCode,'isTwoShow')">
              <gj-input
                  v-if="switchCondition(val.paramCode,'twoDisabled')"
                  v-model="val.conditionName"
                  disabled
                  width="180px"></gj-input>
              <form-type
                  v-else
                  v-model="val.conditionCode"
                  :type="switchCondition(val.paramCode,'twoType')"
                  :options-type="switchCondition(val.paramCode,'optionsType')"
                  :clearable="false"
                  width="180px"
              >
              </form-type>
            </el-form-item>
            <el-form-item v-if="form.warnTitleCode === 'ORDER_WARN_001'" class="right-padding-10">
              上一笔订单商品配送费
            </el-form-item>

<!--            第三列-->
            <el-form-item
                :prop="`value${index}`"
                :rules="switchCondition(val.paramCode,'threeDisabled')?null:switchCondition(val.paramCode,'rules')"
                v-if="switchCondition(val.paramCode,'isShow')"
                class="select-text-width">
              <gj-input
                  v-if="switchCondition(val.paramCode,'threeDisabled') && val.conditionValueDesc"
                  v-model="val.conditionValueDesc"
                  disabled
                  width="180px"></gj-input>

              <form-type
                  v-else
                  v-model="form[`value${index}`]"
                  :clearable="switchCondition(val.paramCode,'threeType') !== 'default'"
                  :type="switchCondition(val.paramCode,'threeType')"
                  :disabled="switchCondition(val.paramCode,'threeDisabled')"
                  :options-type="switchCondition(val.paramCode,'threeOptionsType')"
                  :placeholder="switchCondition(val.paramCode,'threePlaceholder')"
                  width="180px"
              >
              </form-type>
            </el-form-item>

            <div v-if="switchCondition(val.paramCode,'isPercent')" class="message-symbol">%</div>

            <div
                v-if="(form.warnTitleCode === 'DATA_INDEX_WARN_001' || form.warnTitleCode === 'DATA_INDEX_WARN_003')&&val.paramCode==='DATA_INDEX_WARN_CONDITION_001'">
              （市场时间）
            </div>
          </div>
        </el-form-item>

        <el-form-item label="通知对象" required style="margin-bottom: 0">
          <div v-for="(val,index) in userList" :key="val.type" class="flex-message">
            <el-form-item class="right-padding-10">
              <gj-select
                  v-model="val.type"
                  :options="personSelectList"
                  placeholder="人员类型"
                  :clearable="false"
                  width="190px"
                  @change="changeType"
              ></gj-select>
            </el-form-item>
            <el-form-item
                :prop="`person_${val.type}`"
                :rules="{required: true, message: '请选择人员', trigger: 'change'}"
                class="select-text-width">
              <gj-select
                  v-model="form[`person_${val.type}`]"
                  :options="relationList"
                  placeholder="选择人员"
                  type="multi-check"
                  width="190px"
                  :is-show-all-checked="false"
                  :clearable="false"
                  v-if="val.type === 'ASSOCIATE_PERSONNEL'"
              ></gj-select>
              <gj-creator-select
                  v-else
                  v-model="form[`person_${val.type}`]"
                  type="multi-check"
                  width="190px"
                  placeholder="操作用户"
              ></gj-creator-select>
            </el-form-item>
            <el-col :span="4" class="person-icon">
              <i class="el-icon-circle-plus-outline" v-if="userList.length < 2 && index === 0"
                 @click="handleUser()" title="添加"></i>
              <i class="el-icon-remove-outline" v-if="userList.length === 2" @click="handleUser(index, val.type)"
                 title="删除"></i>
            </el-col>
          </div>
        </el-form-item>

<!--        只有店铺绩效预警有通知形式-->
        <el-form-item
            prop="noticeForm"
            label="通知形式"
            required
            :rules="{required: true, message: '请选择通知形式', trigger: 'change'}"
            v-if="warnTypeCode === 'MARKET_PERFORMANCE_WARN'">
          <gj-select
              v-model="form.noticeForm"
              :options="[
                  {id: 'CONDITION_VAL_027', text: '每次通知'},
                  {id: 'CONDITION_VAL_028', text: '数据有差异时通知'},
              ]"
              :width="'140px'"
              :clearable="false"
              :filterable="false"
          >
          </gj-select>
          <span class="colorRed" style="margin-left: 12px;">(请谨慎选择，每次通知是每天只要有预警就推送，数据有差异时通知是数据对比上次有变化时才推送)</span>
        </el-form-item>

        <el-form-item label="提醒方式">
          <gj-checkbox v-model="form.markPro" disabled>站内通知</gj-checkbox>
          <gj-checkbox v-model="form.markApp" disabled>APP通知</gj-checkbox>
          <gj-checkbox v-model="form.markWx" disabled>公众号通知</gj-checkbox>
        </el-form-item>
      </el-form>

      <gj-alert
          type="info"
          :closable="false"
          show-icon
          class="warning-tooltip"
      >
        <div class="warning-content">
          <span>商品预警范围：</span>
          <p>{{ msgExplainRange.split('：')[1] }}</p>
        </div>

        <div class="warning-content">
          <span>更新时间：</span>
          <p>{{ msgExplainRate.split('：')[1] }}</p>
        </div>

        <div class="warning-content">
          <span>内容样式：</span>
          <p>{{ msgContentStyle }}</p>
        </div>

        <div class="warning-content" v-if="msgContentTemplate">
          <span>使用说明：</span>
          <p>{{ msgContentTemplate.split('：')[1] }}</p>
        </div>
      </gj-alert>
    </template>
  </gj-modal>
</template>

<script>
import {formRuleMixin, modalMixIn} from "@/minxins";
import {PERSON_SELECT_LIST, RELATION_LIST, TRIGGER_CONDITION} from "@/utils/condition";
import FormType from "@/views/modules/setting/argument/components/warning/modal/components/form-type";
import {editWarningConfigDesc, getWarningConfigDesc} from "@/api/warning";
import _ from 'lodash';

export default {
  name: "app-warning-edit-modal",
  components: {FormType},
  mixins: [modalMixIn, formRuleMixin],
  props: {
    tplId: {
      default: null
    },
    tplName: {
      default: ''
    },
    msgExplainRange: {
      type: String,
      default: ''
    },
    msgContentStyle: {
      type: String,
      default: ''
    },
    msgExplainRate: {
      type: String,
      default: ''
    },
    msgContentTemplate: {
      type: String,
      default: ''
    },
    warnTypeCode:null
  },

  data() {
    return {
      modalLoading: true,
      form: {
        // 关联人员
        person_ASSOCIATE_PERSONNEL: [],
        // 指定人员
        person_SPECIFY_PERSONNEL: [],
        // 预警标题名称
        warnTitleName: '',
        // 预警标题编码
        warnTitleCode: '',
        // 预警状态
        warnStatus: true,
        // 根据rules不同，来确定判断规则, 后端给我唯一标识，下拉框也根据类型判断获取到对应的数据, 第三个选项框展现形式判断
        conditionList: [],
        // 通知形式
        noticeForm: null,
        noticeFormId: null,
        // 提醒方式
        markPro: true,
        markApp: true,
        markWx: true,
      },
      //  规则
      validateRules: {},
      // 通知对象类型下拉框选择
      personSelectList: PERSON_SELECT_LIST,
      // 关联人员下拉选择
      relationList: _.cloneDeep(RELATION_LIST),
      //  触发条件属性判断规则
      triggerCondition: TRIGGER_CONDITION,
      // 当前预警标题触发条件规则
      currentTrigger: {},
      // 通知对象根据后台返回的值进行格式化初始化
      userList: [],
      //  把要编辑的数据存起来，比较数据是否发生变化
      oldData: null,
    }
  },

  created() {
    this.getDescData();
  },

  methods: {
    // 获取详情
    async getDescData() {
      const arr = ['MARKET_PERFORMANCE_WARN_005', 'MARKET_PERFORMANCE_WARN_001', 'MARKET_PERFORMANCE_WARN_002', 'MARKET_PERFORMANCE_WARN_003', 'MARKET_PERFORMANCE_WARN_004'];
      const {data} = await getWarningConfigDesc(this.tplId);
      // 当不需要销售负责人时
      if (arr.indexOf(data.warnTitleCode) !== -1) {
        this.relationList.pop();
      }

      this.modalLoading = false;

      // 如果data中存在的键也存在于form中，则直接赋值
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(this.form, key)) {
          this.form[key] = data[key];
        }
      }
      this.form.warnStatus = !!this.form.warnStatus;

      // 转化关联人员和指定人员
      // 当存在关联人员
      if (data.relationPersonnelList.length > 0) {
        this.form.person_ASSOCIATE_PERSONNEL = data.relationPersonnelList;
        if (this.form.person_ASSOCIATE_PERSONNEL.indexOf('ASSOCIATE_PERSONNEL_003') === -1) {
          this.form.person_ASSOCIATE_PERSONNEL.unshift('ASSOCIATE_PERSONNEL_003');
        }

        // this.userList.push({type: 'ASSOCIATE_PERSONNEL', person: data.relationPersonnelList});
        this.userList.push({type: 'ASSOCIATE_PERSONNEL'});
      }
      // 当存在指定人员
      if (data.noticeObjectUserIdList.length > 0) {
        this.form.person_SPECIFY_PERSONNEL = data.noticeObjectUserIdList;
        this.userList.push({type: 'SPECIFY_PERSONNEL'});
      }

      // 通过预警标题编码获取触发条件属性
      this.currentTrigger = this.triggerCondition[this.form.warnTitleCode];

      // 将第三个条件赋值到新的value中
      this.form.conditionList.forEach((item, index) => {
        // 如果是差评，那么值需要是数组
        if (this.form.warnTitleCode === 'NEGATIVE_RATINGS_WARN_001' || this.form.warnTitleCode === 'NEGATIVE_RATINGS_WARN_002') {
          this.$set(this.form, `value${index}`, item.conditionValue.split(','));
        } else {
          this.$set(this.form, `value${index}`, item.conditionValue);
        }
      })

      this.oldData = this._.cloneDeep(this.form);

      this.initPersonSelect();
    },

    //  设置人员类型选择的选项是否禁选
    initPersonSelect() {
      this.personSelectList.forEach(item => {
        item.disabled = false;
        this.userList.forEach(value => {
          if (item.id === value.type) {
            item.disabled = true;
          }
        })
      })
    },

    //  当人员类型发生变化时
    changeType(val) {
      this.initPersonSelect();
      // 只要类型状态一改变，就清空值
      this.form.person_ASSOCIATE_PERSONNEL = val === 'ASSOCIATE_PERSONNEL' ? ['ASSOCIATE_PERSONNEL_003'] : [];
      this.form.person_SPECIFY_PERSONNEL = [];
      // this.form[`person_${val}`] = [];
    },

    //  操作通知对象
    handleUser(index, key) {
      if (index || index === 0) {
        // 删除，并将对应表单值清空
        this.userList.splice(index, 1);
        this.form[`person_${key}`] = [];
      } else {
        //  新增数据，
        this.userList.push({
          type: this.userList[0].type === 'ASSOCIATE_PERSONNEL' ? 'SPECIFY_PERSONNEL' : 'ASSOCIATE_PERSONNEL'
        });

        if (this.userList[0].type === 'SPECIFY_PERSONNEL') {
          this.form.person_ASSOCIATE_PERSONNEL = ['ASSOCIATE_PERSONNEL_003'];
        }
      }

      this.initPersonSelect();
    },

    // 提交
    async confirm() {
      if (this.$gjFormValidate()) {
        if (!this.judgeChange()) {
          this.$gjDestroy();
          return false;
        }

        // 重新处理触发条件的数据
        const itemList = this.form.conditionList.map((item, index) => {
          return {
            id: item.id,
            conditionCode: item.conditionCode,
            paramCode: item.paramCode,
            conditionValue: this.form.warnTitleCode === 'NEGATIVE_RATINGS_WARN_001' || this.form.warnTitleCode === 'NEGATIVE_RATINGS_WARN_002' ? this.form[`value${index}`].join(',') : this.form[`value${index}`]
          }
        })

        // 编辑所传参数
        const params = {
          id: this.tplId,
          itemList,
          markApp: this.form.markApp,
          markPro: this.form.markPro,
          markWx: this.form.markWx,
          warnStatus: this.form.warnStatus,
          relationPersonnelList: this.form.person_ASSOCIATE_PERSONNEL,
          noticeObjectUserIdList: this.form.person_SPECIFY_PERSONNEL,
          noticeForm:this.form.noticeForm,
          noticeFormId:this.form.noticeFormId
        }

        // 调用编辑接口
        this.confirmLoading = true;
        try {
          const {data} = await editWarningConfigDesc(params);
          if (data) {
            this.$gjMessage.success('修改成功');
            this.$emit('updated', data.warnStatus);
            this.$gjDestroy();
          }
        } finally {
          this.confirmLoading = false;
        }
      }
    },

    //  触发中间条件发生改变
    changeCondition(index, val) {
      // console.log('值发生改变')
      // console.log(this.form)
      // this.userList[index].person = this.form[`person${val}`];
    },

    // 当触发条件中存在对应的id则获取对应的值，若不存在则在最外层寻找
    switchCondition(key, keyValue) {
      return (this.currentTrigger[key] ? this.currentTrigger[key][keyValue] : this.currentTrigger[keyValue]);
    },

    //  判断数据是否发生改变
    judgeChange() {
      // 先把form克隆下来，一面form发生变化
      let params = this._.cloneDeep(this.form);

      // 触发条件变化
      for (let i = 0; i < params.conditionList.length; i++) {
        //  如果原数组的conditionCode 与 现在的不一样，就返回true
        if (params.conditionList[i].conditionCode !== this.oldData.conditionList[i].conditionCode || params[`value${i}`] !== this.oldData[`value${i}`]) {
          return true;
        }
      }

      // 通知形式变化
      if(params.noticeForm !== this.oldData.noticeForm){
        return true;
      }

      // 通知对象变化
      // 关联人员
      // 如果关联人员、指定人员长度对比发生变化
      if (params.person_ASSOCIATE_PERSONNEL.length !== this.oldData.person_ASSOCIATE_PERSONNEL.length || params.person_SPECIFY_PERSONNEL.length !== this.oldData.person_SPECIFY_PERSONNEL.length) {
        return true;
      }

      const associate1 = params.person_ASSOCIATE_PERSONNEL.sort().join(',');
      const associate2 = this.oldData.person_ASSOCIATE_PERSONNEL.sort().join(',');

      const specify1 = params.person_SPECIFY_PERSONNEL.sort().join(',');
      const specify2 = this.oldData.person_SPECIFY_PERSONNEL.sort().join(',');

      return associate1 !== associate2 || specify1 !== specify2;
    }
  }
}
</script>

<style scoped lang="scss">
.warning-tooltip {
  .warning-content {
    color: #333;
    line-height: 22px;
    display: flex;

    > p {
      margin: 0;
      width: calc(100% - 90px);
    }

    > span {
      display: inline-block;
      width: 90px;
      text-align: right;
      height: 100%;
    }
  }
}

.warning-form {
  /deep/ .el-form-item__label{
    color: #333;
  }

  /deep/ .el-form-item .el-form-item {
    margin-bottom: 18px;
  }

  /deep/ .el-input.is-disabled .el-input__inner {
    background: #F8f8f8;
    color: #999;
  }
}

.flex-message {
  display: flex;

  .message-symbol {
    width: 30px;
    text-align: center;
  }
}

.right-padding-10 {
  padding-right: 10px;
}

.person-icon {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 32px;

  > i {
    font-size: 18px;
    cursor: pointer;
    color: #999;
    margin-left: 20px;

    &:hover {
      color: #1F6EEF;
    }
  }
}

.select-text-width {
  /deep/ .el-select__tags-text {
    max-width: 90px;
  }
}
</style>
